import Partnerships from "./Partnerships"

export default Partnerships
